<template>
  <div class="statistics-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>销售成本统计</span>
      </div>
    </div>

    <div class="search-area">
      <el-select
        v-model="selectedContractNames"
        multiple
        filterable
        placeholder="合同名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in contractNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        v-model="selectedCustomerNames"
        multiple
        filterable
        placeholder="客户名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in customerNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
      <el-button type="success" @click="goToProductDetail" icon="el-icon-s-data">销售产品明细</el-button>
      <el-button v-permission="'statistics:sales-statistics:export'" type="warning" @click="handleExport" icon="el-icon-download" :loading="exportLoading">导出</el-button>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="customerName" label="客户名称" min-width="140" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="140" align="center"></el-table-column>
        <el-table-column prop="contractName" label="合同名称" min-width="180" align="center"></el-table-column>
        <el-table-column prop="contractNumber" label="合同编号" width="160" align="center"></el-table-column>
        <el-table-column prop="salesAmount" label="销售金额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.salesAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="salesCost" label="对应销售成本" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.salesCost) }}
          </template>
        </el-table-column>
        <el-table-column prop="handler" label="业务经办人" width="120" align="center"></el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'SalesStatistics',
  data() {
    return {
      startDate: '',
      endDate: '',
      selectedContractNames: [],
      selectedCustomerNames: [],
      contractNameOptions: [],
      customerNameOptions: [],
      loading: false,
      exportLoading: false,
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadFilterOptions()
    this.loadData()
  },
  methods: {
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.selectedContractNames = []
      this.selectedCustomerNames = []
      this.pagination.currentPage = 1
      this.loadData()
    },
    loadFilterOptions() {
      api.contracts.query_sales_contracts_pagination({ page: 1, size: 500 })
        .then(response => {
          if (response.data && response.data.success) {
            const content = response.data.data?.content || []
            const contractNames = []
            const customerNames = new Set()
            content.forEach(item => {
              if (item.contractName) {
                contractNames.push(item.contractName)
              }
              const names = this.extractCustomerNames(item.contractParties)
              names.forEach(n => customerNames.add(n))
            })
            this.contractNameOptions = [...new Set(contractNames)].sort()
            this.customerNameOptions = [...customerNames].filter(Boolean).sort()
          }
        })
        .catch(() => {})
    },
    extractCustomerNames(contractParties) {
      if (!contractParties || !Array.isArray(contractParties)) return []
      const names = []
      contractParties.filter(p => p.partyType === 'CUSTOMER').forEach(party => {
        const name = party.unitInfo?.unitName || party.unitInfo?.name
        if (name) names.push(name)
      })
      return names
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    goToProductDetail() {
      this.$router.push({ path: '/data/sales-product-detail' })
    },
    handleExport() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      this.exportLoading = true
      const params = {}
      if (this.startDate) params.contractStartDate = this.startDate
      if (this.endDate) params.contractEndDate = this.endDate
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      if (this.selectedCustomerNames && this.selectedCustomerNames.length > 0) {
        params.customerNames = this.selectedCustomerNames
      }
      api.statistics.exportSalesCostStatistics(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = '销售成本统计.xlsx'
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (match) {
              fileName = decodeURIComponent(match[1].replace(/^UTF-8''/, '').trim())
            }
          }
          if (fileName === '销售成本统计.xlsx') {
            const now = new Date()
            const yyyy = now.getFullYear()
            const mm = String(now.getMonth() + 1).padStart(2, '0')
            const dd = String(now.getDate()).padStart(2, '0')
            fileName = `销售成本统计_${yyyy}${mm}${dd}.xlsx`
          }
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatContractDate(dateStr) {
      if (!dateStr) return ''
      return String(dateStr).split('T')[0]
    },
    loadData() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      this.loading = true
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize,
        sortBy: 'contractDate',
        sortDir: 'desc'
      }
      if (this.startDate) params.contractStartDate = this.startDate
      if (this.endDate) params.contractEndDate = this.endDate
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      if (this.selectedCustomerNames && this.selectedCustomerNames.length > 0) {
        params.customerNames = this.selectedCustomerNames
      }
      api.statistics.getSalesCostStatisticsByContract(params)
        .then(response => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
          } else {
            this.tableData = []
            this.$message.error(response.data?.message || '获取销售成本统计失败')
          }
        })
        .catch(err => {
          this.tableData = []
          this.$message.error(err.response?.data?.message || '获取销售成本统计失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409EFF;
  margin-right: 10px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input {
  width: 200px;
}
.select-multi {
  min-width: 200px;
  max-width: 280px;
}
.date-picker {
  width: 200px;
}
.table-area {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
</style>
